import { Component, useContext } from "react";
import Button from "devextreme-react/button";
import { appConst } from "~/app-const";
import { AppContext } from "~/app-context"
import "./login-form.scss";

class LoginFormComponent extends Component {
  render() {
    return (
      <>
        <div className={"login-header"}>
          <img className={"logo"} alt="logo" src="/logo.svg" />
          <div className={"title"}>{appConst.appName}</div>
          <div className={"release"}>Release {appConst.release}</div>
          <div>Sign In using your Microsoft account</div>
          <Button
            type={"default"}
            text={"Sign In"}
            onClick={this.props.onLoginClick}
            width={"100%"}
          />
        </div>
      </>
    );
  }

  onLoginClick = () => {
    this.props.context.onSignIn();
  };
}

export const LoginForm =  (props) => {
 const context = useContext(AppContext);
 return <LoginFormComponent {...props} context={context} />
}